import type { PayloadAction } from '@reduxjs/toolkit';

import { createSlice } from '@reduxjs/toolkit';

import type { Order } from '../../types/types';

interface AppState {
  orders: Order[];
}

// Define the initial state using that type
const initialState: AppState = {
  orders: [],
};
export const AppSlice = createSlice({
  name: 'orders',
  initialState,
  reducers: {
    setAllOrders: (state, action: PayloadAction<Order[]>) => {
      state.orders = action.payload;
    },
    addOrder: (state, action: PayloadAction<Order>) => {
      state.orders = [...state.orders, action.payload];
    },
    updateOrder: (state, action: PayloadAction<Order>) => {
      state.orders = state.orders.map((order) =>
        order.id === action.payload.id ? action.payload : order
      );
    },
  },
});

export const { setAllOrders, updateOrder, addOrder } = AppSlice.actions;
export default AppSlice.reducer;
